<template>
  <div class="search">
    <div class="main-contain">
      <div class="section tip">
        <div class="tip_wrap">
          <div class="tip_item tip1">
            共为您找到
            <span class="color">{{total}}条</span>相关结果
          </div>
          <div class="tip_item tip2">
            文化活动:
            <span>{{ data01.total || 0 }}</span> 条; 活动资讯:
            <span>{{ data02.total || 0 }}</span> 条; 活动图片:
            <span>{{ data03.total || 0 }}</span> 条; 活动直播:
            <span>{{ data04.total || 0 }}</span> 条
          </div>
        </div>
      </div>
      <div class="section">
        <Activity :list="data01.list" :is-more="data01.is_more" @more="getMoreData"></Activity>
      </div>
      <div class="section">
        <News :list="data02.list" :is-more="data02.is_more" @more="getMoreData"></News>
      </div>
      <div class="section">
        <Album :list="data03.list" :is-more="data03.is_more" @more="getMoreData"></Album>
      </div>
      <div class="section">
        <Live :list="data04.list" :is-more="data04.is_more" @more="getMoreData"></Live>
      </div>
    </div>
  </div>
</template>
<script>
import Activity from "@/views/search/components/activity.vue" // 推荐活动
import News from "@/views/search/components/news.vue" // 新闻报道
import Album from "@/views/search/components/album.vue" // 活动图片
import Live from "@/views/search/components/live.vue" // 正在直播
import { getsearchinfo } from "@/api/common"
export default {
  name: "Search",
  components: {
    Activity,
    News,
    Album,
    Live,
  },
  data () {
    return {
      queryObj: {},
      queryParams: {
        page: 1,
      },
      data01: {
        list: []
      },
      data02: {
        list: []
      },
      data03: {
        list: []
      },
      data04: {
        list: []
      },
      page01: 1,
      page02: 1,
      page03: 1,
      page04: 1,
    }
  },
  computed: {
    total () {
      const n1 = this.data01.total || 0
      const n2 = this.data02.total || 0
      const n3 = this.data03.total || 0
      const n4 = this.data04.total || 0
      return Number(n1) + Number(n2) + Number(n3) + Number(n4)
    },
  },
  watch: {
    "$route.query": {
      handler (newVal, oldVal) {
        this.queryObj = newVal || {}
        this.queryParams.keyword = this.queryObj.keyword || ""
        this.queryParams.type = null
        this.queryParams.page = 1
        this.initData()
      },
      immediate: true,
      deep: true,
    }
  },
  created () {
    this.queryObj = this.$route.query || {}
    this.queryParams.keyword = this.queryObj.keyword
    this.queryParams.type = null
    this.queryParams.page = 1
    this.initData()
  },
  methods: {
    initData () {
      this.getinfo()
    },
    // 获取详情数据
    getinfo () {
      getsearchinfo(this.queryParams)
        .then((res) => {
          if (res.code === 0 && res.data) {
            if (res.data.activity_list) {
              this.data01 = this.integrateData(res.data.activity_list, "data01")
            }
            if (res.data.news_list) {
              this.data02 = this.integrateData(res.data.news_list, "data02")
            }
            if (res.data.activity_pic_list) {
              this.data03 = this.integrateData(res.data.activity_pic_list, "data03")
            }
            if (res.data.live_list) {
              this.data04 = this.integrateData(res.data.live_list, "data04")
            }
          }
        })
        .catch(() => { })
    },
    // 整合数据
    integrateData (data, name) {
      const newList = data.data || [] // 获取返回的列表
      const oldList = this[name].data || [] // 获取现有的列表
      const isFull = data.data.length === data.per_page // 当页条数是否占满
      const isLast = data.current_page === data.last_page // 是否是最后一页
      const newdata = data.current_page > 1 ? oldList.concat(newList) : newList
      return {
        list: newdata,
        total: data.total,
        is_more: isFull && !isLast, // 是否加载更多
      }
    },
    getMoreData (val) { // type  关联类型1：新闻 ,2:活动图片,3:活动，5:直播
      switch (val) {
        case 1:
          this.page01++
          this.queryParams.page = this.page01
          break
        case 2:
          this.page02++
          this.queryParams.page = this.page02
          break
        case 3:
          this.page03++
          this.queryParams.page = this.page03
          break
        case 5:
          this.page04++
          this.queryParams.page = this.page04
          break
        default:
          break
      }
      this.queryParams.type = val
      this.getinfo()
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  background: #ffffff;
  .main-contain {
    padding: 30px 30px 10px;
    .section {
      max-width: 1800px;
      margin: 0 auto 30px;
    }
    .tip {
      display: flex;
      justify-content: center;
      align-items: center;
      .tip_wrap {
        text-align: center;
        padding: 10px 30px;
        background-color: rgba(0, 92, 187, 0.05);
        border-radius: 40px;
        .tip_item {
          color: #333333;
          font-size: 18px;
          font-weight: 400;
          line-height: 20px;
          .color {
            color: rgb(0, 92, 187);
            padding: 0px 4px;
          }
        }
        .tip_item.tip2 {
          padding-top: 10px;
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .search {
    .main-contain {
      .section {
        max-width: 640px;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .section-head {
        height: 40px;
        line-height: 40px;
        background-size: auto 50%;
        .section-title {
          font-size: 24px;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .search {
    .main-contain {
      .section {
        max-width: 1200px;
      }
      .section-head {
        .section-title {
          font-size: 30px;
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .search {
    .main-contain {
      .section {
        max-width: 1800px;
      }
      .section-head {
        .section-title {
          font-size: 36px;
        }
      }
    }
  }
}
</style>
